var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-white)",
    d: "M10.5 19.25a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-white)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M10.5 5.83v8.5M6.25 10.92l4.25 4.25 4.25-4.25"
  })));
};
export default SvgFile;